
import Vue from 'vue'
import { myListingNames } from '@/lists'

// Names only, and no link, deliberately.
//
// `GET /api/lists` answers with the caller's active lists whether they are
// public or private, which is the whole reason this route needs a session. The
// detail view behind `/list/:id` reads the public namespace, and a private
// listing is not served there, so a link from here would either dead-end on a
// `404` or need this route to grow a private detail view -- duplicating or
// refactoring the detail views, which is out of scope for this piece of work.
//
// So the route says what the user's lists are called and stops there. A future
// private detail route is a route to add, not something to pretend at here.
export default Vue.extend({
  name: 'MyLists',

  data: () => ({
    names: [] as string[],
    failure: ''
  }),

  created () {
    this.load()
  },

  methods: {
    async load () {
      try {
        this.names = await myListingNames()
      } catch (error) {
        // A `401` here is the response interceptor's business: it has already
        // cleared the session and asked for a sign-in, and this screen is on its
        // way out. Reporting it here as well would put an error on a screen
        // nobody is going to see. Anything else is worth saying.
        if ((error as any).response === undefined || (error as any).response.status !== 401) {
          this.failure = 'Your lists could not be loaded. Please try again.'
        }
      }
    }
  }
})
